import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewContainerRef,
  forwardRef,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GalaxyAbstractFilterInput, GalaxyFilterInputOverride, GalaxyFilterValueInterface } from '../interface';

@Component({
  selector: 'glxy-custom-filter-input',
  template: ` <ng-template #filterOverrideComponent></ng-template> `,
  providers: [{ provide: GalaxyAbstractFilterInput, useExisting: forwardRef(() => GalaxyCustomFilterInputComponent) }],
  imports: [CommonModule],
  standalone: true,
})
export class GalaxyCustomFilterInputComponent implements GalaxyAbstractFilterInput, AfterViewInit {
  @Input({ required: true }) filterOverride!: GalaxyFilterInputOverride;
  _initialValues: GalaxyFilterValueInterface[] = [];
  @Input() set initialValue(values: GalaxyFilterValueInterface[]) {
    this._initialValues = values;
  }
  @Output() valueChanges = new EventEmitter<GalaxyFilterValueInterface[]>();
  @ViewChild('filterOverrideComponent', { static: false, read: ViewContainerRef }) overrideRef?: ViewContainerRef;

  private readonly destroyRef = inject(DestroyRef);
  constructor(private ref: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (!this.filterOverride) {
      console.error('No override found for filter input');
      return;
    }

    const viewContainerRef = this.overrideRef;
    if (!viewContainerRef) return;

    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<GalaxyAbstractFilterInput>(this.filterOverride.filterInput);
    componentRef.instance.initialValue = this._initialValues;
    componentRef.instance.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: GalaxyFilterValueInterface[]) => {
        this.valueChanges.emit(value);
      });
    this.ref.detectChanges();
  }

  clearValue() {
    const viewContainerRef = this.overrideRef;
    viewContainerRef?.clear();
    this._initialValues = [];
  }
}
